import React from 'react';
import PropTypes from 'prop-types';

import './read_only_field.scss';

const ReadOnlyField = ({ label, value }) => {
  if (!value) {
    return null;
  }

  return (
    <div className="read-only-field">
      <strong className="read-only-label">{label}</strong>
      <span className="read-only-value">{value}</span>
    </div>
  );
};

ReadOnlyField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
};

export default ReadOnlyField;
